import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SkeletonComponent } from '@components/skeleton/skeleton.component';

@Component({
  selector: 'app-followers-followings-skeleton',
  templateUrl: './followers-followings-skeleton.component.html',
  styleUrls: ['./followers-followings-skeleton.component.scss'],
  standalone: true,
  imports: [CommonModule, SkeletonComponent]
})
export class FollowersFollowingsSkeletonComponent {
  @Input() showHeading = true;

  readonly cardIndices = new Array(6);
}
